/*
 *
 * PblManagement Actions
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 30-Jun-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_FETCH_PBLS: '@@pblManagement/fetch_pbls',
  DO_FETCH_PBL_DETAILS: '@@pblManagement/fetch_pbl_details',
  DO_DELETE_OR_UPDATE_LINK: '@@pblManagement/delete_or_update_link',
  DO_EXPORT_PBL: '@@pblManagement/export_pbl',
  DO_RESEND_LINK: '@@pblManagement/resend_link',
  DO_SET_PBL_SOURCE_PAGE: '@@pblManagement/set_pbl_source_page',
  DO_FETCH_PBL_VERSION_SETTINGS: '@@pblManagement/fetch_pbl_version_settings',
  // @generator action:route:type
  ...createRequestTypes('@@pblManagement', 'GET_PBLS'),
  ...createRequestTypes('@@pblManagement', 'DELETE_OR_UPDATE_LINK'),
  ...createRequestTypes('@@pblManagement', 'GET_PBL_DETAILS'),
  ...createRequestTypes('@@pblManagement', 'RETRIEVE_PBL_EXPORT_FILE'),
  ...createRequestTypes('@@pblManagement', 'GET_PBL_VERSION_SETTINGS')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
 * * Insert a description
 * @name getPblsList
 * @return {object} - The action object
 */
export const getPblsList = new MakeRequest('pblManagement', 'get_pbls')

/** @action request
 * * Insert a description
 * @name retreivePblsExportFile
 * @return {object} - The action object
 */
export const retrievePblsExportFile = new MakeRequest('pblManagement', 'retrieve_pbls_export_file')

/** @action request
 * * Insert a description
 * @name deleteOrUpdateLink
 * @return {object} - The action object
 */
export const deleteOrUpdateLink = new MakeRequest('pblManagement', 'delete_or_update_link')

/** @action request
 * * Insert a description
 * @name getPblDetails
 * @return {object} - The action object
 */
export const getPblDetails = new MakeRequest('pblManagement', 'get_pbl_details')

/** @action request
 * * Insert a description
 * @name getPblVersionSettings
 * @return {object} - The action object
 */
export const getPblVersionSettings = new MakeRequest('pblManagement', 'get_pbl_version_settings')

// @generator action
/** @action
 * * Insert a description
 * @name SetPblSourcePage
 * @return {object} - The payload object
 */
export const doSetPblSourcePage = (payload) => createAction(actionTypes.DO_SET_PBL_SOURCE_PAGE, { payload })

/** @action
 * * Insert a description
 * @name ResendLink
 * @return {object} - The payload object
 */
export const doResendLink = (payload) => createAction(actionTypes.DO_RESEND_LINK, { payload })
/** @action
 * * Insert a description
 * @name doFetchPblsList
 * @return {object} - The action object
 */
export const doFetchPblsList = (payload) => createAction(actionTypes.DO_FETCH_PBLS, { payload })

/** @action
 * * Insert a description
 * @name DeleteOrUpdateLink
 * @return {object} - The payload object
 */
export const doDeleteOrUpdateLink = (payload) => createAction(actionTypes.DO_DELETE_OR_UPDATE_LINK, { payload })

/** @action
 * * Insert a description
 * @name ExportPbl
 * @return {object} - The payload object
 */
export const doExportPbl = (payload) => createAction(actionTypes.DO_EXPORT_PBL, { payload })

/** @action
 * * Insert a description
 * @name FetchPblDetails
 * @return {object} - The payload object
 */
export const doFetchPblDetails = (payload) => createAction(actionTypes.DO_FETCH_PBL_DETAILS, { payload })

/** @action
 * * Insert a description
 * @name FetchPblVersionSettings
 * @return {object} - The payload object
 */
export const doFetchPblVersionSettings = (payload) =>
  createAction(actionTypes.DO_FETCH_PBL_VERSION_SETTINGS, { payload })
